// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionsCarousel-cls1___a830d297d27cf5febc2","cls2":"SuggestionsCarousel-cls2__cb1391fba712332a8ee1 SuggestionsCarousel-cls1___a830d297d27cf5febc2"};